export default `サンプル：１行目がタイトルになります。
２行目以降もプレビューに表示されます。

tabmemoをご利用いただきありがとうございます。
こちらのメモはサンプルですので、すぐ削除していただいて構いません。

アプリ版の場合は一覧画面でメモを長押しすることでメニューが開きメモを削除できます。

ブラウザ版の場合はメモ一覧部分のゴミ箱マークをクリックすることで削除できます。

もしtabmemoを使っていてなにか困った事などがございましたら、左上のボタンを押して出るメニューのお問い合わせからご連絡ください。できるだけ早く対応させていただきます。

今後も様々な機能を追加していく予定ですので、ご要望等もありましたら同じくお問い合わせや、twitterで@nabettu宛にご連絡いただければ幸いです。

tabmemoを通してあなたのメモライフがより良くなるよう願っております。`;
